import React, { useEffect } from "react";
import { initSparrowSurvey } from "../../../utils/Helper";
import { get } from "lodash";

const SurveySparrow = (props) => {
  useEffect(() => {
    initSparrowSurvey(get(props, "data"), get(props, "isRejected", false));
    
    // Override SurveySparrow's inline styles after it loads
    const overrideStyles = () => {
      const surveyWidget = document.getElementById("ss_survey_widget");
      if (surveyWidget) {
        // Override container styles
        surveyWidget.style.width = "100%";
        surveyWidget.style.height = "100%";
        
        // Find and override iframe styles
        const iframe = surveyWidget.querySelector("iframe");
        if (iframe) {
          iframe.style.width = "100%";
          iframe.style.height = "100%";
          iframe.style.border = "none";
          iframe.style.borderRadius = "15px";
        }
      }
    };
    
    // Try to override styles immediately and after a delay
    overrideStyles();
    const timeoutId = setTimeout(overrideStyles, 1000);
    const intervalId = setInterval(overrideStyles, 500);
    
    return () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
      const surveyWidget = document.getElementById("ss-widget");
      get(surveyWidget, "parentElement.tagName") === "BODY" &&
        document.body.removeChild(surveyWidget);
    };
  }, []);
  return (
    <div id="ss_survey_widget"></div>
  );
};

export default SurveySparrow;
